var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-363.000000, -259.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(363.000000, 259.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75,0 L1.25,0 C0.5625,0 0,0.5625 0,1.25 L0,8.75 C0,9.4375 0.5625,10 1.25,10 L8.75,10 C9.4375,10 10,9.4375 10,8.75 L10,1.25 C10,0.5625 9.4375,0 8.75,0 L8.75,0 Z M2.5,1.25 C3.1875,1.25 3.75,1.8125 3.75,2.5 C3.75,3.1875 3.1875,3.75 2.5,3.75 C1.8125,3.75 1.25,3.1875 1.25,2.5 C1.25,1.8125 1.8125,1.25 2.5,1.25 L2.5,1.25 Z M0.625,9.375 L0.625,8.1875 L1.75,6.6875 C2.1875,6.125 2.875,6.125 3.3125,6.625 L5.5,9.3125 L0.625,9.3125 L0.625,9.375 Z M9.375,9.375 L6.25,9.375 L5,7.75 L7.0625,5.125 C7.5,4.5625 8.1875,4.5625 8.625,5.125 L9.4375,6.1875 L9.4375,9.375 L9.375,9.375 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.e3df6f4b56ae1b83c8fb86f7518a00b7.svg";
export { ForwardRef as ReactComponent };